import ViewIcon from "./view"

const Icon = ({
    className,
}: { 
    className: string;
}) => {
    return <div className={className}>
        <ViewIcon />
    </div>
}

export default Icon;